function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/css'; //wait for the DOM to load

document.addEventListener('DOMContentLoaded', function () {
  //listen for click events on the document
  document.addEventListener('click', function (event) {
    //check if the clicked element is a scroll-to link
    if (event.target.matches('.scroll-to')) {
      //prevent the default link behavior
      event.preventDefault();
      var current_block = event.target.closest('.flexi-block'); //find all flexi blocks

      var blocks = document.querySelectorAll('.flexi-block'); //if we have some blocks

      if (blocks && blocks.length > 0) {
        for (var i = 0; i < blocks.length; i++) {
          //if the block is the current block and there's one after it...
          if (blocks[i] === current_block && blocks[i + 1]) {
            //...scroll to the next block
            blocks[i + 1].scrollIntoView({
              behavior: 'smooth'
            });
            break;
          }
        }
      }
    }
  });
});

function defaultSwiperSettings() {
  var slidesPerView = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var speed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var autoplay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var autoHeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return {
    modules: [Navigation, Pagination, Autoplay],
    autoplay: autoplay,
    speed: speed,
    slidesPerView: slidesPerView,
    centerInsufficientSlides: true,
    autoHeight: autoHeight,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    a11y: true
  };
}

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelectorAll('.heroslider')) {
    //find all the sliders
    var sliders = document.querySelectorAll('.heroslider');

    if (sliders) {
      sliders.forEach(function (slider) {
        var paginationElement = slider.querySelector('.swiper-pagination');

        if (paginationElement) {
          // Initialize the swiper instance
          new Swiper(slider, _objectSpread(_objectSpread({}, defaultSwiperSettings(1, 700, {
            disableOnInteraction: false
          })), {}, {
            on: {
              activeIndexChange: function activeIndexChange(swiper) {
                slider.setAttribute('data-active', swiper.activeIndex + 1);
              }
            },
            pagination: {
              el: paginationElement,
              clickable: true,
              freeMode: true,
              renderBullet: function renderBullet(index, className) {
                return '<button aria-label="Go to slide ' + (index + 1) + '" class="' + className + '"></button>';
              }
            }
          }));
        }
      });
    }

    document.addEventListener('click', function (event) {
      //if this is a play or pause button
      if (event.target.matches('button[data-action="play"]') || event.target.matches('button[data-action="pause"]')) {
        //determine if we're playing or pausing...
        var play = event.target.dataset.action === 'play'; //find the closest parent with class heroslider

        var swiperContainer = event.target.closest('.heroslider'); //if we found the parent

        if (swiperContainer) {
          var swiperInstance = swiperContainer.swiper; //find the play and pause buttons

          var play_button = play ? event.target : swiperContainer.querySelector('button[data-action="play"]');
          var pause_button = !play ? event.target : swiperContainer.querySelector('button[data-action="pause"]'); //indicates whether or not the current slide has a video

          var video_slides = swiperContainer.querySelectorAll('.video-clip'); // Determine if we need to handle play/pause for videos or the swiper

          var shouldHandleSwiper = swiperInstance && swiperInstance.slides && swiperInstance.slides.length > 1;
          var shouldHandleVideo = video_slides.length > 0; //if this button was to play the current slide

          if (play) {
            if (shouldHandleSwiper) {
              // Start the autoplay
              swiperInstance.autoplay.start();
            } //if there is at least one video in the slider


            if (shouldHandleVideo) {
              //loop over each video and play it
              video_slides.forEach(function (video) {
                video.play();
              });
            } //hide the play button and show the pause button


            play_button.classList.add('hidden');
            pause_button.classList.remove('hidden');
          } else {
            //otherwise, this button was to pause the current slide
            if (shouldHandleSwiper) {
              // Stop the autoplay
              swiperInstance.autoplay.stop();
            } //if there is at least one video in the slider


            if (shouldHandleVideo) {
              //loop over each video and pause it
              video_slides.forEach(function (video) {
                video.pause();
              });
            } //hide the pause button and show the play button


            play_button.classList.remove('hidden');
            pause_button.classList.add('hidden');
          }
        }
      }
    });
  }
});